<rt-select2
  [formControl]="sortControl.controls.sortingId"
  [items]="sortingItems()"
  [overlayWidth]="DropdownWidth.SmallX"
>
  <rt-select-header>
    {{ 'app.views.sorting.sort_by' | translate }}
  </rt-select-header>
  <rt-icon-button
    *rtSelectTrigger="let selectCtrl"
    variant="tertiary"
    [iconName]="sortControl.value?.direction === 'desc' ? 'sort-descending' : 'sort-ascending'"
    [active]="!!sortControl.value?.sortingId"
    [pressed]="selectCtrl.isOpen()"
    (click)="selectCtrl.toggle(true)"
    [class]="buttonClass()"
  />
  <rt-dropdown-item
    *rtSelectListItem="let selectCtrl; let item = item; let isHoverState = isHoverState"
    [class.hover]="isHoverState"
    (click)="toggleSorting(item)"
  >
    {{ item.label }}
    @if (selectCtrl.itemSelector.isSelected(item)) {
      <rt-icon
        suffix
        colorToken="colorIconPrimaryDefault"
        [name]="sortControl.value?.direction === 'desc' ? 'sort-descending' : 'sort-ascending'"
      />
    }
  </rt-dropdown-item>
</rt-select2>
